import AudioManager from "../Shared/AudioManager";
import { Global } from "../Shared/Global";
import GameList from "../Models/GameList";

const {ccclass, property} = cc._decorator;

@ccclass
export default class FilterGameType extends cc.Component {
    @property(cc.ScrollView)
    svTypes: cc.ScrollView = null

    @property(cc.Mask)
    mask: cc.Mask = null

    @property(cc.Node)
    layerTopsGames: cc.Node = null
    
    @property(cc.Node)
    layerChessAndCard: cc.Node = null
    
    @property(cc.Node)
    layerFish: cc.Node = null
    
    @property(cc.Node)
    layerLiveVideo: cc.Node = null
    
    @property(cc.Node)
    layerElectronic: cc.Node = null
    
    @property(cc.Node)
    layerSports: cc.Node = null
    
    @property(cc.Node)
    layerLottery: cc.Node = null
    
    @property(cc.Node)
    layerESports: cc.Node = null

    private _type2Layer = {}
    private _curLayer = null
    private _gameTypt2Name = {
        "": "topgames",
        [Global.GameType.Chess]: "chessandcard",              
        [Global.GameType.Fish]: "fish",               
        [Global.GameType.ESport]: "esports",             
        [Global.GameType.Electronic]: "electronic",         
        [Global.GameType.Live]: "livevideo",               
        [Global.GameType.Sport]: "sports",              
        [Global.GameType.Lottery]: "lottery",            
    }

    onLoad () {
        this._type2Layer = {
            topgames: this.layerTopsGames,
            chessandcard: this.layerChessAndCard,
            fish: this.layerFish,
            livevideo: this.layerLiveVideo,
            electronic: this.layerElectronic,
            sports: this.layerSports,
            lottery: this.layerLottery,
            esports: this.layerESports,
        }

        // 为了触发onLoad
        this.layerTopsGames.active = true
        this.layerChessAndCard.active = true
        this.layerFish.active = true
        this.layerLiveVideo.active = true
        this.layerElectronic.active = true
        this.layerSports.active = true
        this.layerLottery.active = true
        this.layerESports.active = true
        cc.director.on(Global.UserEvent.GameListChanged, this.sortGameTypes, this)
    }

    start () {
        // 延迟是为了widget组件初始化适配
        this.scheduleOnce(function () {
            // 初始化隐藏
            this.layerChessAndCard.active = false
            this.layerFish.active = false
            this.layerLiveVideo.active = false
            this.layerElectronic.active = false
            this.layerSports.active = false
            this.layerLottery.active = false
            this.layerESports.active = false
        }, 0.05)     

        // 默认选择热门
        this.showLayer(this._gameTypt2Name[""])
    }

    onDestroy () {
        cc.director.off(Global.UserEvent.GameListChanged, this.sortGameTypes, this)
    }

    onFilter (toggle: cc.Toggle) {
        AudioManager.playSound("toggle")
        this.showLayer(toggle.node.name)
        this.checkScroll(toggle)
    }

    private showLayer (name) {
        if (this._curLayer) {
            this._curLayer.active = false
        }

        this._curLayer = this._type2Layer[name]
        this._curLayer.active = true
    }

    private checkScroll (toggle: cc.Toggle) {
        let toggleBottom = -toggle.node.height * toggle.node.anchorY
        let maskBottom = -this.mask.node.height * this.mask.node.anchorY

        if (toggle.node.convertToWorldSpaceAR(cc.v2(0, toggleBottom)).y - this.mask.node.convertToWorldSpaceAR(cc.v2(0, maskBottom)).y < 20) {
            this.svTypes.scrollToBottom(1)
        }else {
            let toggleTop = -toggle.node.height * toggle.node.anchorY + toggle.node.height
            let maskTop = -this.mask.node.height * this.mask.node.anchorY + this.mask.node.height

            if (this.mask.node.convertToWorldSpaceAR(cc.v2(0, maskTop)).y - toggle.node.convertToWorldSpaceAR(cc.v2(0, toggleTop)).y < 20) {
                this.svTypes.scrollToTop(1)
            }
        }
    }

    private sortGameTypes () {
        for (const key in this._gameTypt2Name) {
            cc.find(this._gameTypt2Name[key], this.node).active = false
        }
        for (let i = 0; i < GameList.serverData["tabList"].length; i++) {
            const cfg = GameList.serverData["tabList"][i];
            let gameType = cfg.gameTypes ? parseInt(cfg.gameTypes) : ""
            let toggle = cc.find(this._gameTypt2Name[gameType], this.node).getComponent(cc.Toggle)
            let lbName = toggle.node.getChildByName("name_label").getComponent(cc.Label)
            toggle.node.active = true
            toggle.node.zIndex = i
            lbName.string = cfg.categoryName
            i === 0 && toggle.check()
        }
    }
}
